module.exports = __webpack_public_path__ + "static/media/ic-regframe-active.bc275d4f.svg";